(() => {
  if (window.KudenHomeAmbientVideo) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const conserveData = Boolean(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
  const videos = new Map();

  const canHydrate = () => !reducedMotion.matches && !conserveData;

  const setToggleState = (record, isPlaying) => {
    if (!record.toggle) return;
    const label = isPlaying ? record.toggle.dataset.pauseLabel : record.toggle.dataset.playLabel;
    record.toggle.textContent = label;
    record.toggle.setAttribute('aria-label', label);
  };

  const pause = (record) => {
    record.video.pause();
    setToggleState(record, false);
  };

  const play = (record) => {
    if (record.userPaused || !canHydrate()) return;
    const promise = record.video.play();
    if (promise) promise.catch(() => setToggleState(record, false));
    setToggleState(record, true);
  };

  const hydrate = (record) => {
    if (record.hydrated || !canHydrate()) return;
    record.video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    record.hydrated = true;
    record.video.load();
    record.video.addEventListener('loadeddata', () => {
      record.section.classList.add('is-video-ready');
      if (record.toggle) record.toggle.hidden = false;
    }, { once: true });
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const record = videos.get(entry.target);
          if (!record) return;
          record.isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          if (record.isVisible) {
            hydrate(record);
            play(record);
          } else {
            pause(record);
          }
        });
      }, { threshold: [0, 0.15, 0.5] })
    : null;

  const register = (section) => {
    if (videos.has(section)) return;
    const video = section.querySelector('[data-kuden-ambient-video-element]');
    if (!video) return;
    const toggle = section.querySelector('[data-kuden-video-toggle]');
    const record = { section, video, toggle, hydrated: false, userPaused: false, isVisible: false };
    videos.set(section, record);

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (video.paused) {
          record.userPaused = false;
          hydrate(record);
          play(record);
        } else {
          record.userPaused = true;
          pause(record);
        }
      });
    }

    if (observer) observer.observe(section);
    else {
      hydrate(record);
      play(record);
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-kuden-ambient-video]').forEach(register);
  };

  const suspendAll = () => videos.forEach(pause);
  reducedMotion.addEventListener?.('change', (event) => {
    if (event.matches) suspendAll();
    else videos.forEach((record) => {
      if (!record.isVisible) return;
      hydrate(record);
      play(record);
    });
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) suspendAll();
    else videos.forEach((record) => record.isVisible && play(record));
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('DOMContentLoaded', () => init());
  init();

  window.KudenHomeAmbientVideo = { init };
})();
